module.exports = __webpack_public_path__ + "static/dealwatch1-6116dfee111523f3efc851b5ae2f2a95.png";